// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__200O-","title":"Info_title__A1sN0","selects":"Info_selects__2BbQJ","requiredAsterisk":"Info_requiredAsterisk__3fW22"};